module.exports = __webpack_public_path__ + "static/media/invite-selected.3cd02129.svg";